export var RouteStates;
(function (RouteStates) {
    RouteStates[RouteStates["NOT_ROUTABLE"] = 0] = "NOT_ROUTABLE";
    RouteStates[RouteStates["NOT_ROUTED"] = 1] = "NOT_ROUTED";
    RouteStates[RouteStates["ROUTE_IN_PROGRESS"] = 2] = "ROUTE_IN_PROGRESS";
    RouteStates[RouteStates["ROUTE_FAILURE"] = 3] = "ROUTE_FAILURE";
    RouteStates[RouteStates["ROUTE_SUCCESS"] = 4] = "ROUTE_SUCCESS";
})(RouteStates || (RouteStates = {}));
